// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3p-R0","requiredAsterisk":"Info_requiredAsterisk__P6WzO"};